export default __webpack_public_path__ + "static/ApercuMonoProMedium-ad889cfb9a7cd5deaf40a0cf4b0d7042.woff";